import React, { useState, useEffect, useRef } from 'react';
import ModalDialog, { DialogContent } from '../../AlmeDialog/ModalDialog';
import loadTransmitSDK from './loadTransmitSDK';
import { getAlmeSessionData } from '../../AlmeApp/AlmeAppSessionState';
import styled from 'styled-components';
import SyfLoader from 'syf-component-library/ui/atoms/Loader/SyfLoader';
import ErrorBoundary from '../../ErrorBoundary/ErrorBoundary';
const TransmitDialogContent = styled(DialogContent) `
  padding: 0;
`;
const TransmitFormOverlay = (props) => {
    const [isOpen, setIsOpen] = useState(true);
    const [loaded, setLoaded] = useState(!!window.iva_transmit_sdk);
    const initialized = useRef(false);
    useEffect(() => {
        async function startTrasmitWorkflow() {
            try {
                const almeSessionData = getAlmeSessionData();
                const authenticationParams = Object.assign(Object.assign({}, JSON.parse(props.responseAction.TransmitStartParams)), { user_id: almeSessionData === null || almeSessionData === void 0 ? void 0 : almeSessionData.userId });
                const authenticationResult = await window
                    .iva_transmit_sdk
                    .authenticate('transmitContainer', authenticationParams);
                await props.onTransmitAuthComplete('TransmitResult', authenticationResult, 'Internal');
            }
            catch (e) {
                console.error("Transmit error", e);
                setIsOpen(false);
            }
        }
        if (!loaded) {
            loadTransmitSDK(props.ivaWebUrl, () => setLoaded(true), (e) => {
                console.error("Unable to download transmit SDK", e);
                setIsOpen(false);
            });
        }
        if (loaded && !initialized.current) {
            initialized.current = true;
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            startTrasmitWorkflow();
        }
    }, [props, loaded]);
    return (isOpen
        ?
            React.createElement(ErrorBoundary, { appConfig: props.appConfig },
                React.createElement(ModalDialog, { id: 'data-collection-dialog', "aria-labelledby": "data-collection-dialog-title", "aria-describedby": "data-collection-dialog-description", noBackground: true },
                    React.createElement(TransmitDialogContent, null,
                        React.createElement("div", { "data-testid": "transmitContainer", id: 'transmitContainer' },
                            React.createElement(SyfLoader, { size: 5 })))))
        : null);
};
export default TransmitFormOverlay;
